import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import { contacts } from "../../../../utils/contact";
import "./style.css";

<ScrollLink to="cleaning-service" smooth={true} duration={500}>
  Services
</ScrollLink>;

const AboutArea = () => {
  const { t } = useTranslation();
  return (
    <>
      <section className="tp-about-area position-relative pt-120 pb-90 fix">
        <div className="tp-about-shape" id="whoWeAre">
          <img
            src="assets/img/about/about-shape-1.jpg"
            className="img-fluid"
            alt="img not found"
          />
        </div>
        <div className="container">
          <div className="row justify-content-xl-between justify-content-md-center">
            <div className="col-xl-5 col-12">
              <div
                className="tp-about-img z-index wow fadeInUp"
                data-wow-delay=".3s"
              >
                <img
                  src="assets/img/about/about-img-1.jpg"
                  alt="img not found"
                />
              </div>
            </div>
            <div className="col-xl-6 col-md-10">
              <div
                className="tp-about-text z-index wow fadeInUp"
                data-wow-delay=".6s"
              >
                <div className="section-title-wrapper mb-30">
                  <h5 className="tp-section-subtitle section__sm__title common-yellow-shape mb-20">
                    {t("AboutArea.aboutOurCompany")}
                  </h5>
                  <h2 className="tp-section-title">
                    {t("AboutArea.aboutOurCompanySubText")}
                  </h2>
                </div>
                <p className="mb-40">{t("AboutArea.HassleFree")}</p>

                <div className="row">
                  <div className="col-sm-6">
                    <div className="tp-about-number mb-30">
                      <div className="tp-about-number-icon px-10">
                        <i className="flaticon-phone-call-1"></i>
                      </div>
                      <div className="tp-about-number-text">
                        {t("AboutArea.FreeConsultacy")}
                        <div className="row">
                          <a href={`tel:${contacts.tel.replaceAll(" ", "")}`}>
                            {contacts.tel}
                          </a>
                          <a href={`tel:${contacts.tel2.replaceAll(" ", "")}`}>
                            {contacts.tel2}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="content mb-15 hover-theme-colo ml-23">
                    <strong> {t("AboutArea.Mission")}</strong>:{" "}
                    {t("AboutArea.MissionText")}
                  </div>
                  <div
                    className="col-xxl-6 col-xl-51"
                    style={{ marginRight: "45px" }}
                  >
                    <div className="tp-header-top-info justify-content-end1 mt-65">
                      <div className="tp-header-top-info-single1">
                        <div className="tp-header-top-info-single-btn1">
                          <Link to="/quote" className="yellow-btn">
                            <i className="flaticon-enter"></i>
                            {t("AboutArea.MoreInfo")}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="row mb-10 about-area_items">
        <div className="col-sm-6">
          <div className="tp-about-service mb-30 mt-50 ml-40 mr-30">
            <div className="tp-about-service-icon yellow-circle-shape mb-15">
              <i className="flaticon-snowfall"></i>
            </div>
            <div className="tp-about-service-text">
              <h4 className="tp-about-service-text-title mb-15 hover-theme-color">
                <Link to="/quote/residential">
                  {t("AboutArea.Residential")}
                </Link>
              </h4>
              <p>{t("AboutArea.ResidentialText")}</p>
            </div>
          </div>
          <div className="tp-about-serve ml-40 mt-65">
            {t("AboutArea.General")}
            <br />
            {t("AboutArea.Deep")}
            <p id="cleaning-service">
              <a href="#">{t("AboutArea.MoveCleaning")}</a>
            </p>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="tp-about-service mb-30 mt-50 ml-40 mr-30">
            <div className="tp-about-service-icon yellow-circle-shape mb-15">
              <i className="flaticon-business-and-trade"></i>
            </div>
            <div className="tp-about-service-text">
              <h4 className="tp-about-service-text-title mb-15 hover-theme-color">
                <Link to="/quote/commercial">
                  {t("AboutArea.CommercialCleaning")}
                </Link>
              </h4>
              <p className="Residential Cleaning Servies ">
                {t("AboutArea.CommercialCleaningText")}
              </p>
            </div>
          </div>
          <div className="tp-about-serve ml-40 mt-65">
            {t("AboutArea.General")}
            <br />
            {t("AboutArea.Deep")}
            <p id="cleaning-service">
              <a href="#">{t("AboutArea.MoveCleaning")}</a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutArea;
